import {
  EcommerceNavigationAction,
  LOAD_ECOMMERCE_MENU_LIST, LOAD_ECOMMERCE_MENU_LIST_FAIL,
  LOAD_ECOMMERCE_MENU_LIST_SUCCESS,
  LoadEcommerceMenuList, LoadEcommerceMenuListFail, LoadEcommerceMenuListSuccess
} from "../actions";
import {IMenuItem} from "../../websites/website/ecommerce/ecommerce-menu/navigation.interface";

export interface IEcommerceNavigationEntityState {
  menus: IMenuItem[];
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceNavigationState {
  entities: { [websiteId: number]: IEcommerceNavigationEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceNavigationState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceNavigationState = initialState, action: EcommerceNavigationAction): IEcommerceNavigationState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_MENU_LIST:
      payload = (<LoadEcommerceMenuList>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_MENU_LIST_SUCCESS:
      payload = (<LoadEcommerceMenuListSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            menus: payload.menus,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_MENU_LIST_FAIL:
      payload = (<LoadEcommerceMenuListFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
